import { create } from "zustand";
import { persist } from "zustand/middleware";

export type PortalLanguage = "en" | "ar";

type PortalLanguageState = {
  language: PortalLanguage;
  setLanguage: (lang: PortalLanguage) => void;
  toggle: () => void;
};

/** Apply the document direction so the entire portal shell mirrors in RTL. */
export const applyPortalDirection = (lang: PortalLanguage) => {
  if (typeof document === "undefined") return;
  document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = lang;
};

/** Reset direction to LTR (used when leaving the portal, e.g. on logout). */
export const resetPortalDirection = () => {
  if (typeof document === "undefined") return;
  document.documentElement.dir = "ltr";
  document.documentElement.lang = "en";
};

export const usePortalLanguage = create<PortalLanguageState>()(
  persist(
    (set, get) => ({
      language: "en",
      setLanguage: (lang) => {
        applyPortalDirection(lang);
        set({ language: lang });
      },
      toggle: () => {
        const next: PortalLanguage = get().language === "en" ? "ar" : "en";
        applyPortalDirection(next);
        set({ language: next });
      },
    }),
    {
      name: "portal-language",
      onRehydrateStorage: () => (state) => {
        if (state) applyPortalDirection(state.language);
      },
    }
  )
);

